module.exports = __webpack_public_path__ + "static/img/u5.b702fb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newUi-icon/u5.png
// module id = KySK
// module chunks = 96